import React from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { get, post } from "helpers/api_helper";
import { getActiveTelecallerListAPIURL, submitManulCallRequestAPIURL } from 'BaseComponentAPI/ManualEntryAPI';
import axios from 'axios';
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';


const ManualEntry = () => {
  document.title = "Call Request | Cockpit";

  const authUser = useSelector(state => state.Login);
  const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
  const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

  const [userOptions, setUserOptions] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
  const [popupType, setPopupType] = useState('');  // Set the type from passed state
  
  // 🔹 TEMP user list (UI only – will come from API later)
//   const userOptions = [
//     { value: "1", label: "User One" },
//     { value: "2", label: "User Two" },
//     { value: "3", label: "User Three" }
//   ];


    useEffect(() => {
        getTelecallerList();
    }, [authUser]);

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const getTelecallerList = async () => {
    setLoadingUsers(true);

    if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                    
                const response = await axios.get(
                            `${getActiveTelecallerListAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                            {
                                headers: { ...authUser.headers },
                                'Authorization': `Bearer ${authUser.headers.access_token}`
                            }
                        );        

                if (response?.data?.responseCode === 0) {
                const userOptions =
                    response.data.data.items?.map(user => ({
                    value: user.userUUID,
                    label: `${user.firstName} ${user.lastName} (${user.userName})`,
                    })) || [];

                setUserOptions(userOptions);                
                }
                else
                {
                    console.error('API Response Error:', response.data.responseMsg);
                    //setLoaderOption(false);
                    openPopup('Something went wrong!', 'error')
                }
            } catch (error) {
                console.error("Error fetching telecaller list", error);
                openPopup('Something went wrong!', 'error')
                
            } finally {
                setLoadingUsers(false);
            }
    }
    };

   
  
  const formik = useFormik({
    initialValues: {
      customerMobile: "",
      assignedUser: null,
      referencePerson: "",
      userRemark: ""
    },
    validationSchema: Yup.object({
      customerMobile: Yup.string()
        .required("Customer mobile number is required")
        .matches(/^[6-9]\d{9}$/, "Enter valid 10 digit mobile number"),

      assignedUser: Yup.object()
        .nullable()
        .required("Please select user"),

      referencePerson: Yup.string()
        .required("Reference person name is required")
        .min(2, "Minimum 2 characters")
        .max(30, "Maximum 30 characters allowed"),


      userRemark: Yup.string()
        .max(200, "Maximum 200 characters allowed")
    }),
    onSubmit: async (values, { resetForm }) => {
    setSubmitting(true);

    const payload = {
      customerMobile: values.customerMobile,
      assigneToUserUUID: values.assignedUser?.value,
      referencePerson: values.referencePerson,
      remark: values.userRemark
    };

    try {
      const response = await post(
        submitManulCallRequestAPIURL,        
        payload,
        {
          headers: { ...authUser.headers },
          'Authorization': `Bearer ${authUser.headers.access_token}`
        }
      );

      //alert(response.responseCode);
      
      if (response?.responseCode === 0) {
        //alert(response.data.responseMsg); // can replace with PopupWindow
         openPopup(response.responseMsg, "success");
         resetForm();
      }
    } catch (error) {
      console.error("Submit Call Request API Error:", error);
      //alert("Something went wrong. Please try again.");


          // ✅ HTTP status code (404, 401, 500, etc.)
        const statusCode = error?.response?.status;

        if (statusCode === 404) {
          //alert("API not found (404)");
          openPopup("Requested Data Not Found / 404. Please contact admin!", "warn");          
        } else if (statusCode === 401) {
          openPopup("Unauthorized user. Please login", "error");
          //alert("Unauthorized. Please login again.");
        } else if (statusCode === 500) {
          //alert("Server error. Please try later.");
          openPopup("System issue, please contact admin !!", "error");
        } else {
          //alert("Something went wrong.");
          openPopup("System issue, please contact admin !!!", "error");
        }


    } finally {
      setSubmitting(false);
    }
  }
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Forms"
            breadcrumbItem="Manual Entry"/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form onSubmit={formik.handleSubmit}>

                      <Row>
                        {/* Customer Mobile */}
                        <Col lg={6} md={12}>
                            <FormGroup>
                            <Label>
                                Customer Mobile<span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                name="customerMobile"
                                placeholder="Enter customer mobile"
                                value={formik.values.customerMobile}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                formik.touched.customerMobile &&
                                !!formik.errors.customerMobile
                                }
                            />
                            {formik.touched.customerMobile && formik.errors.customerMobile && (
                                <div className="text-danger font-size-12">
                                {formik.errors.customerMobile}
                                </div>
                            )}
                            </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        {/* Assign To User */}
                        <Col lg={6} md={12}>
                            <FormGroup>
                            <Label>
                                Assign To User<span className="text-danger">*</span>
                            </Label>
                            {/* <Select
                                name="assignedUser"
                                options={userOptions}
                                value={formik.values.assignedUser}
                                onChange={value =>
                                formik.setFieldValue("assignedUser", value)
                                }
                                onBlur={() =>
                                formik.setFieldTouched("assignedUser", true)
                                }
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                            /> */}


                            <Select
                                    id="assignedUserId"
                                    name="assignedUser"
                                    className="form-control-md"
                                    options={userOptions}
                                    value={formik.values.assignedUser}                                                                                        
                                    placeholder="Select user"
                                    maxMenuHeight={200}  
                                    onChange={value =>
                                        formik.setFieldValue("assignedUser", value)
                                    }
                                    onBlur={() =>
                                        formik.setFieldTouched("assignedUser", true)
                                    }
                                    classNamePrefix="react-select"                                   
                                />

                            {/* <Select
                            name="assignedUser"
                            options={userOptions}
                            value={formik.values.assignedUser}
                            className="form-control-md"
                            isLoading={loadingUsers}
                            isClearable
                            placeholder="Select user"
                            onChange={value =>
                                formik.setFieldValue("assignedUser", value)
                            }
                            onBlur={() =>
                                formik.setFieldTouched("assignedUser", true)
                            }
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                            /> */}

                            {formik.touched.assignedUser &&
                                formik.errors.assignedUser && (
                                <div className="text-danger font-size-12">
                                    {formik.errors.assignedUser}
                                </div>
                                )}
                            </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        {/* Reference Person */}
                        <Col lg={6} md={12}>
                            <FormGroup>
                            <Label>
                                Reference Person<span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                name="referencePerson"
                                placeholder="Enter reference person name"
                                value={formik.values.referencePerson}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                formik.touched.referencePerson &&
                                !!formik.errors.referencePerson
                                }
                            />
                            {formik.touched.referencePerson &&
                                formik.errors.referencePerson && (
                                <div className="text-danger font-size-12">
                                    {formik.errors.referencePerson}
                                </div>
                                )}
                            </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        {/* User Remark */}
                        <Col lg={6} md={12}>
                            <FormGroup>
                            <Label>User Remark (Max 200 chars)</Label>
                            <Input
                                type="textarea"
                                name="userRemark"
                                rows="3"
                                placeholder="Enter remark"
                                value={formik.values.userRemark}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <div className="text-muted font-size-11 text-end">
                                {formik.values.userRemark.length}/200
                            </div>
                            {formik.touched.userRemark &&
                                formik.errors.userRemark && (
                                <div className="text-danger font-size-12">
                                    {formik.errors.userRemark}
                                </div>
                                )}
                            </FormGroup>
                        </Col>
                        </Row>

                        {/* Submit Button */}
                        <Row>
                        <Col>
                            <Button type="submit" color="primary" disabled={submitting}>
                              {submitting ? "Submitting..." : "Send Request"}
                            </Button>
                        </Col>
                        </Row>


                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
       {isPopupVisible && (
                              <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                          )}
    </React.Fragment>
  );
};

export default ManualEntry;
